<template>

    <div class="modal fade" :id="modalId" role="dialog" tabindex="-1">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header bg-indigo text-white border-0">
                    <h5 class="modal-title">
                        <i class="ph-image icon-modal-size me-2"></i>{{ title }}
                    </h5>
                    <button type="button" class="btn btn-light btn-sm btn-icon border-transparent rounded-pill" data-bs-dismiss="modal">
                        <i class="ph-x icon-x-size"></i>
                    </button>
                </div>
                <div class="modal-body">

                    <div class="text-center mb-3">
                        <img v-if="avatar.id > 0 && avatar.url != 'placeholder.jpg'" :src="filters.getImgPath(folder,avatar.url)" class="img-fluid rounded border" style="max-width: 35rem;" alt="" />
                        <span v-else class="btn-nophoto rounded fs-sm d-inline-flex align-items-center justify-content-center" style="width: 180px; height: 120px !important; line-height: 13px; padding-top: 12px; font-size: 0.7rem !important;">No<br />Photo</span>
                    </div>

                </div>
                <div class="modal-footer bg-light p-1">
                    <button type="button" class="btn btn-link" data-bs-dismiss="modal"><i class="fal fa-sign-out-alt fa-fw me-1"></i> CHIUDI</button>
                    <button v-if="avatar.url && avatar.url != 'placeholder.jpg' && !avatarWebp" type="button" class="btn btn-outline-info" v-on:click="convertiWebp()"><i class="ph-user-switch me-1"></i> Converti in WebP</button>
                    <UploadCloud mode="button" button-class="btn btn-indigo text-white float-end" button-icon="ph-upload" :modalita="'CORE_uploadImgAllegati'" :args="uploadArgs" :multiple="false" :show-preview="false" @uploaded="onUploaded($event)"></UploadCloud>
                </div>
            </div>
        </div>
    </div>

</template>


<script>

import UploadCloud from '@/components/utils/UploadCloud.vue'

export default {
    name: 'AvatarUploader',

    components: {
        UploadCloud
    },

    props: {
        folder: {
            type: String,
            default: 'PRODOTTI'
        },
        title: {
            type: String,
            default: 'Immagine'
        },
        modalId: {
            type: String,
            default: 'avatarUploaderModal'
        }
    },

    data: function () {
        return {
            filters: global.filters,
            avatar: {
                id: 0,
                url: 'placeholder.jpg'
            }
        }
    },

    computed: {
        uploadArgs: function () {
            return {
                FOLDER: this.folder,
                ID: this.avatar.id
            }
        },
        avatarWebp: function () {
            return /\.webp$/i.test(String(this.avatar.url || ''));
        }
    },

    methods: {

        open: function (opts) {
            this.avatar.id = (opts && opts.id) ? opts.id : 0;
            this.avatar.url = (opts && opts.url) ? opts.url : 'placeholder.jpg';
            var el = document.getElementById(this.modalId);
            if (!el) { return; }
            if (!this._bsModal) {
                this._bsModal = new bootstrap.Modal(el);
                el.addEventListener('hide.bs.modal', function () {
                    if (document.activeElement && el.contains(document.activeElement)) {
                        document.activeElement.blur();
                    }
                });
            }
            this._bsModal.show();
        },

        extractUrl: function (item) {
            var url = (item && item.url) ? item.url : (item && item.data && item.data.url) ? item.data.url : '';
            url = String(url || '');
            var prefix = this.folder + '/';
            if (url.indexOf(prefix) === 0) {
                url = url.substring(prefix.length);
            }
            return url;
        },

        onUploaded: function (item) {
            var nomeAvatar = this.extractUrl(item);
            if (nomeAvatar == '') {
                utils.alert.warning("Immagine non caricata correttamente");
                return;
            }
            this.avatar.url = nomeAvatar;
            this.$emit('uploaded', nomeAvatar, item);
        },

        convertiWebp: function () {
            if (this.avatar.id == 0 || this.avatar.url == '' || this.avatar.url == 'placeholder.jpg') {
                return;
            }
            var prefisso = String(this.avatar.url).indexOf(this.folder + '/') === 0 ? this.avatar.url : this.folder + '/' + this.avatar.url;
            utils.ajax("core/immagine/converti", { PATH_IMG: prefisso }, (response) => {
                if (response.esito == 0 && response.data && response.data.file) {
                    var nuovoFile = String(response.data.file).replace(new RegExp('^' + this.folder + '/'), '');
                    this.avatar.url = nuovoFile;
                    this.$emit('uploaded', nuovoFile, response.data);
                }
                else {
                    utils.alert.warning((response && response.messaggio) ? response.messaggio : "Conversione non riuscita");
                }
            });
        }

    }

}
</script>


<style scoped>
</style>
